module.exports = __webpack_public_path__ + "img/Ma.Maritime.Breakwaters.ConcreteArmourUnits-15m.Massconcrete.fdab21ad.png";